const init = e => {
    console.log('Running custom scripts...');

    // Product tabbed section
    const productTabLink = document.querySelectorAll('.product-section-tabs--link');
    if(productTabLink.length) {
        productTabLink.forEach(tab => {
            tab.addEventListener('click', function(e) {
                e.preventDefault();
                const contentNum = e.target.getAttribute('data-tab');
                const activeTab = document.querySelector('.product-section-tabs--link.active');
                const activeContent = document.querySelector('.product-section-tabs--content.active');
                const tabToDisplay = document.querySelector(`.product-section-tabs--content[data-tab="${contentNum}"]`);
                activeContent.classList.remove('active');
                activeTab.classList.remove('active');
                e.target.classList.add('active');
                tabToDisplay.classList.add('active');
            });
        })
    }

    document.querySelectorAll('.read-more-link').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();
    
            document.querySelector(this.getAttribute('href')).scrollIntoView({
                behavior: 'smooth'
            });
        });
    });

    document.querySelectorAll('.js-play-video').forEach(link => {
        link.addEventListener('click', function (e) {
            const videoId = e.target.dataset.video;
            const video = document.querySelector(`video#${videoId}`);
            if(video) {
                const videoContainer = video.closest('.video-hidden');
                if(videoContainer) {
                    videoContainer.style.zIndex = 1;
                }
                if (video.paused == true) {
                    video.play(); 
                } else {
                    video.pause();
                }
            }
        });
    });

}
document.addEventListener('DOMContentLoaded', init, false);
